import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Media, Player, controls } from 'react-media-player';

import Typography from '@material-ui/core/Typography';

import SimplePlayButton from './elements/SimplePlayButton';
import StandardPlayButton from './elements/StandardPlayButton';
import MuteUnmute from './elements/MuteUnmute';
import SeekBar from './elements/SeekBar';

const { CurrentTime, Duration } = controls;

const PlayerControls = styled.div`
  display: flex;
  align-items: center;
  height: 60px;
  overflow-x: hidden;
  > * {
    margin: 0 10px;
  }
`;

const MobileHiddenPlayerControls = styled(PlayerControls)`
  width: 100%;

  @media (max-width: 400px) {
    display: none;
  }
`;

class AudioPlayer extends React.PureComponent {
  render() {
    const { file } = this.props;
    return (
      <Media>
        <PlayerControls>
          <StandardPlayButton />
          <MobileHiddenPlayerControls>
            <Typography variant="overline">
              <CurrentTime />
            </Typography>
            <SeekBar />
          </MobileHiddenPlayerControls>
          <Typography variant="overline">
            <Duration />
          </Typography>
          <MuteUnmute />
          <Player src={file?.url} vendor="audio" />
        </PlayerControls>
      </Media>
    );
  }
}

AudioPlayer.propTypes = {
  file: PropTypes.object.isRequired
};

class SimpleAudioPlayer extends React.PureComponent {
  render() {
    const { file } = this.props;
    return (
      <Media>
        <Fragment>
          <SimplePlayButton />
          <Player src={file.url} vendor="audio" />
        </Fragment>
      </Media>
    );
  }
}

SimpleAudioPlayer.propTypes = {
  file: PropTypes.object.isRequired
};

export { AudioPlayer, SimpleAudioPlayer };
